export const EVENTS = {
    PERSONAL_DETAILS: "personal-details-continue",
    FINANCING: "financing-continue",
    TRADE_IN: "tradein-continue",
    INITIAL_REQUEST: "buy-request-continue"
};
